import { render, staticRenderFns } from "./ZoomOutImg.vue?vue&type=template&id=50817534&scoped=true&"
import script from "./ZoomOutImg.vue?vue&type=script&lang=ts&"
export * from "./ZoomOutImg.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomOutImg.vue?vue&type=style&index=0&id=50817534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50817534",
  null
  
)

export default component.exports